(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brellano-photo-strip"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const initialize = root => {
    if (!root || instances.has(root)) return;
    const viewport = root.querySelector('.photo-strip__viewport');
    const track = root.querySelector('.photo-strip__track');
    const group = root.querySelector('.photo-strip__group');
    const toggle = root.querySelector('.photo-strip__toggle');
    const cards = [...group.children];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const life = new AbortController();
    const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, {...options, signal:life.signal});
    let cycle = 0, position = 0, frame = 0, previous = 0, visible = false, hovered = false, focused = false, selected = false;
    let paused = root.dataset.autoplay !== 'true', ignoreInteraction = false;
    const speed = Math.max(10, Math.min(80, Number(root.dataset.speed) || 40));
    const canMove = () => !paused && !motion.matches && (ignoreInteraction || (!hovered && !focused)) && !selected && visible && !document.hidden && cycle > 0 && cards.length > 1;
    const stop = () => {cancelAnimationFrame(frame);frame=0;previous=0;};
    const tick = now => {
      frame=0;
      if (!canMove()) {previous=0;return;}
      if (previous) {
        position=(position + Math.min(now-previous,50)*speed/1000)%cycle;
        viewport.scrollLeft=position;
      }
      previous=now;
      frame=requestAnimationFrame(tick);
    };
    const update = () => {
      if(!hovered && !focused) ignoreInteraction=false;
      toggle.hidden=cards.length<2;
      toggle.disabled=motion.matches;
      const play=paused || motion.matches;
      toggle.setAttribute('aria-label',motion.matches ? 'Photo scrolling disabled by reduced motion preference' : play ? 'Play photo scrolling' : 'Pause photo scrolling');
      toggle.setAttribute('aria-pressed',String(!play));
      /* SVG parts have no .hidden property, so the attribute is set directly. */
      toggle.querySelector('[data-photo-pause]').toggleAttribute('hidden',play);
      toggle.querySelector('[data-photo-play]').toggleAttribute('hidden',!play);
      root.dataset.scrolling=canMove() ? 'playing' : 'paused';
      if (canMove() && !frame) frame=requestAnimationFrame(tick);
      else if (!canMove()) stop();
    };
    const measure = () => {
      cycle=group.getBoundingClientRect().width;
      track.querySelectorAll('[data-photo-clone]').forEach(copy=>copy.remove());
      if (cycle>0 && cards.length>1) {
        const copies=Math.ceil(viewport.clientWidth/cycle)+1;
        for(let i=0;i<copies;i++) {
          const copy=group.cloneNode(true);
          copy.dataset.photoClone='true';copy.setAttribute('aria-hidden','true');copy.setAttribute('inert','');copy.removeAttribute('role');
          copy.querySelectorAll('[data-shopify-editor-block],[data-photo-block],[id]').forEach(item=>{item.removeAttribute('data-shopify-editor-block');item.removeAttribute('data-photo-block');item.removeAttribute('id');});
          copy.querySelectorAll('img').forEach(image=>{image.alt='';});
          track.append(copy);
        }
        position=viewport.scrollLeft%cycle;
        viewport.scrollLeft=position;
      }
      update();
    };
    const pauseForInteraction = () => {paused=true;ignoreInteraction=false;update();};
    listen(toggle,'click',()=>{position=cycle ? viewport.scrollLeft%cycle : 0;paused=!paused;ignoreInteraction=!paused;update();});
    listen(viewport,'pointerdown',pauseForInteraction,{passive:true});
    listen(viewport,'wheel',event=>{if(event.shiftKey || Math.abs(event.deltaX)>Math.abs(event.deltaY))pauseForInteraction();},{passive:true});
    listen(viewport,'keydown',event=>{
      if(['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown'].includes(event.key)) pauseForInteraction();
    });
    listen(root,'pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;update();}});
    listen(root,'pointerleave',()=>{hovered=false;update();});
    listen(root,'focusin',()=>{focused=true;update();});
    listen(root,'focusout',event=>{if(!root.contains(event.relatedTarget)){focused=false;update();}});
    listen(document,'visibilitychange',update);
    listen(motion,'change',update);
    const editorSection=root.closest('.shopify-section') || root;
    listen(editorSection,'shopify:section:select',()=>{selected=true;update();});
    listen(editorSection,'shopify:section:deselect',()=>{selected=false;update();});
    listen(root,'shopify:block:select',event=>{
      selected=true;update();
      const card=cards.find(item=>item.dataset.photoBlock===event.detail?.blockId);
      if(card) viewport.scrollLeft=card.offsetLeft-track.offsetLeft-20;
    });
    listen(root,'shopify:block:deselect',()=>{selected=false;update();});
    const resize=new ResizeObserver(measure);resize.observe(viewport);
    const intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.01});intersection.observe(root);
    const destroy=()=>{stop();life.abort();resize.disconnect();intersection.disconnect();instances.delete(root);};
    instances.set(root,{destroy});
    measure();
  };
  const findRoots=target=>target.querySelectorAll('[data-brellano-photo-strip]');
  findRoots(document).forEach(initialize);
  document.addEventListener('shopify:section:load',event=>findRoots(event.target).forEach(initialize));
  document.addEventListener('shopify:section:unload',event=>findRoots(event.target).forEach(root=>instances.get(root)?.destroy()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brellano-preview-shell"] && !Shopify.designMode) return;
  try {
    
(() => {
function calculateBrellanoGiftPreview(lines) {
  const normalize = value => {
    const number = Number(value);
    return Number.isFinite(number) ? Math.max(0, Math.min(99, Math.floor(number))) : 0;
  };
  const eligiblePlush = lines.reduce((count, line) => {
    if (line.kind !== 'plush' || line.eligible !== true) return count;
    return count + normalize(line.quantity) * normalize(line.plushPerOffer);
  }, 0);
  const gifts = Math.floor(eligiblePlush / 3);
  const remainder = eligiblePlush % 3;
  const phase = eligiblePlush === 0 ? 'empty' : remainder === 0 ? 'unlocked' : remainder === 1 ? 'add_two' : 'add_one';
  return {
    eligiblePlush,
    gifts,
    modeledPayableUnits: eligiblePlush - gifts,
    unitsToNextGift: eligiblePlush === 0 ? 3 : remainder === 0 ? 3 : 3 - remainder,
    progressUnits: eligiblePlush > 0 && remainder === 0 ? 3 : remainder,
    phase,
    monetaryGiftSavings: null,
    protectionEligible: false,
    protectionEnabled: false,
    protectionFee: null,
    shippingFee: null,
    taxes: null,
    checkoutEnabled: false,
    termsApproved: false
  };
}

  const initialize = root => {
    if (!root || root.dataset.brellanoInitialized) return;
    root.dataset.brellanoInitialized = 'true';
    const all = selector => [...root.querySelectorAll(selector)];
    const openers = new WeakMap();
    let galleryIndex = 0;
    const dialogs = all('dialog');
    const open = (id, opener) => {
      const dialog = dialogs.find(item => item.id === id);
      if (!dialog || dialog.open) return;
      dialogs.filter(item => item.open).forEach(item => item.close());
      openers.set(dialog, opener);
      dialog.showModal();
      document.body.classList.add('brellano-dialog-open');
      all(`[data-brellano-open="${id}"]`).forEach(button => button.setAttribute('aria-expanded','true'));
    };
    const navigate = href => {
      const target = root.querySelector(href);
      if (!target) return;
      requestAnimationFrame(() => {
        target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        const heading = target.querySelector('h1,h2') || target;
        heading.setAttribute('tabindex','-1');
        heading.focus({preventScroll:true});
      });
    };
    const showGallery = index => {
      const gallerySize=Math.max(1,root.querySelectorAll('#BrellanoGallery [data-brellano-slide]').length);
      galleryIndex=((index%gallerySize)+gallerySize)%gallerySize;
      all('[data-brellano-slide]').forEach(slide => {slide.hidden = Number(slide.dataset.brellanoSlide) !== galleryIndex;});
      all('[data-brellano-gallery]').forEach(button => {
        const selected = Number(button.dataset.brellanoGallery) === galleryIndex;
        button.classList.toggle('is-active',selected);
        button.setAttribute('aria-pressed',String(selected));
      });
      const count = `${String(galleryIndex+1).padStart(2,'0')} / ${String(gallerySize).padStart(2,'0')}`;
      all('[data-brellano-gallery-count],#photo-count').forEach(element => {element.textContent=count;});
      const rail=root.querySelector('.gallery-thumbnails'),activeThumb=rail.querySelector('[data-brellano-gallery="'+galleryIndex+'"]');
      if(activeThumb){const left=activeThumb.offsetLeft,right=left+activeThumb.offsetWidth;if(left<rail.scrollLeft)rail.scrollLeft=left;else if(right>rail.scrollLeft+rail.clientWidth)rail.scrollLeft=right-rail.clientWidth;}
      const stockLabel=root.querySelector('[data-brellano-stock-label]');
      if(stockLabel){const catalog=JSON.parse(root.querySelector('[data-brellano-family-catalog]').textContent),src=root.querySelector('#BrellanoGallery [data-brellano-slide="'+galleryIndex+'"] img')?.getAttribute('src');let pictured=null,picturedFamily=null;catalog.families.some(f=>f.variants.some(v=>{if((v.approved_gallery||f.approved_gallery).some(photo=>photo.src===src)){pictured=v;picturedFamily=f;return true;}return false;}));stockLabel.textContent=pictured?.sold_out?'Sold out':'Limited stock available';stockLabel.hidden=false;}
    };
    all('[data-brellano-open]').forEach(button => button.addEventListener('click',()=>open(button.dataset.brellanoOpen,button)));
    all('[data-brellano-close]').forEach(button => button.addEventListener('click',()=>button.closest('dialog').close()));
    dialogs.forEach(dialog => {
      dialog.addEventListener('close',()=>{
        all(`[data-brellano-open="${dialog.id}"]`).forEach(button=>button.setAttribute('aria-expanded','false'));
        if (!dialogs.some(item=>item.open)) document.body.classList.remove('brellano-dialog-open');
        const opener = openers.get(dialog);
        if (opener?.isConnected) opener.focus({preventScroll:true});
      });
      dialog.addEventListener('click',event=>{
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX<bounds.left || event.clientX>bounds.right || event.clientY<bounds.top || event.clientY>bounds.bottom) dialog.close();
      });
      dialog.addEventListener('keydown',event=>{
        if(event.key==='Tab') {
          const controls=[...dialog.querySelectorAll('button,a[href],input,select,textarea,summary,[tabindex]:not([tabindex="-1"])')].filter(element=>!element.disabled && element.getClientRects().length && getComputedStyle(element).visibility!=='hidden');
          const first=controls[0],last=controls[controls.length-1];
          if(!first) return;
          if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
          if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
        }
      });
    });
    all('[data-brellano-nav]').forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();
      link.closest('dialog')?.close();
      navigate(link.getAttribute('href'));
    }));
    root.addEventListener('click',event=>{const button=event.target.closest('[data-brellano-gallery]');if(button)showGallery(Number(button.dataset.brellanoGallery));});
    root.addEventListener('brellano:gallery-reset',event=>showGallery(event.detail?.index||0));
    all('[data-brellano-gallery-direction]').forEach(button=>button.addEventListener('click',()=>showGallery(galleryIndex+Number(button.dataset.brellanoGalleryDirection))));
    const galleryKeyboard = event => {
      const target=event.target;
      if(!target.closest('#BrellanoGalleryDialog,.gallery')||target.matches('input,textarea,select,[contenteditable="true"]'))return;
      const key=event.key||event.code;
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(key))return;
      const size=root.querySelectorAll('#BrellanoGallery [data-brellano-slide]').length;
      if(size<2)return;
      event.preventDefault();event.stopPropagation();
      showGallery(key==='Home'?0:key==='End'?size-1:galleryIndex+(key==='ArrowLeft'?-1:1));
      if(target.hasAttribute('data-brellano-gallery'))root.querySelector('.gallery-thumbnails [data-brellano-gallery="'+galleryIndex+'"]')?.focus({preventScroll:true});
    };
    root.addEventListener('keydown',galleryKeyboard,true);
    const swipeStage=root.querySelector('.photo-stage');let swipeStart=null;
    swipeStage.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'&&!event.target.closest('button'))swipeStart={x:event.clientX,y:event.clientY};},{passive:true});
    swipeStage.addEventListener('pointerup',event=>{if(!swipeStart)return;const dx=event.clientX-swipeStart.x,dy=event.clientY-swipeStart.y;swipeStart=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))showGallery(galleryIndex+(dx<0?1:-1));},{passive:true});
    swipeStage.addEventListener('pointercancel',()=>{swipeStart=null;},{passive:true});
  };
  document.querySelectorAll('[data-brellano-draft]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>initialize(event.target.querySelector('[data-brellano-draft]')));
})();


(() => {
  /* Buy box: family cards (Meet the cans), deal tiers, crew slots and color rail.
     Bundles are picked on the page: tap a color to fill the next spot in the crew. */
  /* off = share taken off each 'free' plush. Must match the two automatic discounts in Shopify:
     'Buy 2 get 1 free' (85.71% off 1 → 3 for $59.98 at $27.99) and 'Buy 4, get 2 free' (94.61% off 2 → 6 for $114.98). */
  const OFFERS={single:{qty:1,paid:1,off:0},trio:{qty:3,paid:2,off:0.8571},crew:{qty:6,paid:4,off:0.9461}};
  const SHIP_USD=4.61,FREE_SHIP_USD=55;
  const initBuyBox=root=>{
    const source=root.querySelector('[data-brellano-family-catalog]');
    if(!source||root.dataset.brellanoFamiliesInitialized)return;
    root.dataset.brellanoFamiliesInitialized='true';
    const catalog=JSON.parse(source.textContent),families=catalog.families;
    const allMedia=[...new Map(families.flatMap(f=>f.variants.flatMap(v=>v.approved_gallery||f.approved_gallery)).map(item=>[item.src,item])).values()];
    const localized=JSON.parse(root.querySelector('[data-brellano-localized-prices]')?.textContent||'{"currency":"USD","variants":{}}');
    const currency=localized.currency||'USD',localPrices=localized.variants||{};
    const reduceMotion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const money=value=>value==null?'':new Intl.NumberFormat('en-US',{style:'currency',currency}).format(value);
    const round=value=>Math.round(value*100)/100;
    const famOf=key=>families.find(f=>f.key===key);
    const details=choice=>{const f=famOf(choice.family);return {family:f,variant:f?.variants.find(v=>v.key===choice.color)};};
    const unitPrice=v=>{const p=Number(localPrices[v?.variant_id]?.price);return p>0?p/100:null;};
    const comparePrice=v=>{const c=Number(localPrices[v?.variant_id]?.compare),p=unitPrice(v);return c>0&&p!=null&&c/100>p?c/100:null;};
    const buyable=choice=>{const {variant:v}=details(choice);if(!v)return false;const p=localPrices[v.variant_id];return v.available===true&&!v.sold_out&&v.bundle_selectable!==false&&!!v.variant_id&&p?.available===true&&Number(p.price)>0;};
    const buyablePrices=families.flatMap(f=>f.variants.filter(v=>buyable({family:f.key,color:v.key})).map(unitPrice));
    const basePrice=buyablePrices.length?Math.min(...buyablePrices):null;
    const firstBuyable=f=>f.variants.find(v=>buyable({family:f.key,color:v.key}));
    let family=families.find(f=>firstBuyable(f))||families[0];
    let variant=firstBuyable(family)||family.variants[0];
    let offer='single',galleryReady=false;
    const remembered=new Map();
    const slots=Array(6).fill(null);
    const q=selector=>root.querySelector(selector);
    const picker=q('[data-brellano-family-picker]'),info=q('.product-info'),gallery=q('.gallery'),section=q('.product-section');
    const rail=q('[data-brellano-color-options]'),crew=q('[data-bx-crew]'),slotsNode=q('[data-bx-slots]'),buy=q('[data-brellano-family-buy]'),status=q('[data-brellano-family-status]');
    const isBundle=()=>offer!=='single';
    const target=()=>OFFERS[offer];
    const picked=()=>slots.slice(0,target().qty).filter(Boolean);
    const compact=()=>{const filled=slots.filter(Boolean);slots.fill(null);filled.slice(0,6).forEach((c,i)=>{slots[i]=c;});};
    const total=key=>{
      const o=OFFERS[key];
      if(key==='single')return unitPrice(variant)??basePrice;
      if(basePrice==null)return null;
      const prices=(key===offer?slots.slice(0,o.qty).filter(Boolean).map(c=>unitPrice(details(c).variant)).filter(p=>p!=null):[]);
      while(prices.length<o.qty)prices.push(basePrice);
      prices.sort((a,b)=>a-b);
      return round(prices.reduce((sum,p)=>sum+p,0)-prices.slice(0,o.qty-o.paid).reduce((sum,p)=>sum+round(p*o.off),0));
    };
    const fullPrice=key=>basePrice==null?null:round(basePrice*OFFERS[key].qty);
    const shipText=()=>currency==='USD'?'+ '+money(SHIP_USD)+' shipping':'+ shipping';
    const resize=()=>{if(window.matchMedia('(max-width:760px)').matches)section.insertBefore(picker,gallery);else info.insertBefore(picker,info.querySelector('.offer-picker'));};
    resize();window.addEventListener('resize',resize,{passive:true});
    const bxW=(u,w)=>u?u.replace(/([?&])width=\d+/,'$1width='+w):u;
    const img=(item,w)=>{const el=document.createElement('img');el.src=bxW(item.src,w||300);el.alt=item.alt||'';el.width=800;el.height=1000;el.loading='lazy';return el;};
    const railButtons=()=>rail.closest('.color-slider').querySelectorAll('[data-brellano-color-direction]');
    const railArrows=()=>railButtons().forEach(b=>{b.disabled=Number(b.dataset.brellanoColorDirection)<0?rail.scrollLeft<=1:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-1;});
    rail.addEventListener('scroll',railArrows,{passive:true});
    if('ResizeObserver' in window)new ResizeObserver(railArrows).observe(rail);
    const countIn=(f,v)=>slots.slice(0,target().qty).filter(c=>c&&c.family===f&&c.color===v).length;
    const renderRail=()=>{
      const keep=rail.scrollLeft;rail.replaceChildren();
      [...family.variants].sort((a,b)=>Number(!!a.sold_out)-Number(!!b.sold_out)).forEach(v=>{
        const choice={family:family.key,color:v.key},ok=buyable(choice),count=isBundle()?countIn(family.key,v.key):0;
        const b=document.createElement('button');b.type='button';
        const active=!isBundle()&&v.key===variant.key;
        b.className='family-color bx-swatch'+(active?' is-active':'')+(count?' is-picked':'')+(ok?'':' is-sold-out');
        b.dataset.brellanoColor=v.key;b.setAttribute('aria-pressed',String(isBundle()?count>0:active));
        b.setAttribute('aria-label',isBundle()?(ok?'Add '+family.label+' '+v.label+' to your crew'+(count?', '+count+' picked':''):family.label+' '+v.label+', sold out'):family.label+' '+v.label+(ok?'':', sold out'));
        const swatch=v.approved_swatch||(v.approved_gallery||family.approved_gallery)[0];b.append(img(swatch));
        const name=document.createElement('span');name.textContent=v.label;b.append(name);
        if(!ok){const sold=document.createElement('small');sold.className='sold-out-label';sold.textContent='Sold out';b.append(sold);}
        else if(count){const badge=document.createElement('i');badge.className='bx-count';badge.textContent=String(count);b.append(badge);}
        else if(isBundle()){const plus=document.createElement('i');plus.className='bx-plus';plus.setAttribute('aria-hidden','true');plus.textContent='+';b.append(plus);}
        b.disabled=!ok;rail.append(b);
      });
      rail.scrollLeft=keep;
      const active=rail.querySelector('.is-active');if(active&&!isBundle()){const l=active.offsetLeft,r=l+active.offsetWidth;if(l<rail.scrollLeft)rail.scrollLeft=l;else if(r>rail.scrollLeft+rail.clientWidth)rail.scrollLeft=r-rail.clientWidth;}
      railArrows();
    };
    const renderSlots=()=>{
      crew.hidden=!isBundle();
      q('[data-brellano-color-picker] legend').textContent=isBundle()?'Tap a color to add it':'Color';
      if(!isBundle())return;
      const o=target(),count=picked().length;
      q('[data-bx-crew-progress]').textContent=count+' of '+o.qty+' picked';
      slotsNode.replaceChildren();
      for(let i=0;i<o.qty;i++){
        const choice=slots[i];
        if(choice){
          const {family:f,variant:v}=details(choice);
          const b=document.createElement('button');b.type='button';b.className='bx-slot';b.dataset.bxRemove=String(i);
          b.setAttribute('aria-label','Remove '+v.label+' '+f.label+' from your crew');
          b.append(img((v.approved_gallery||f.approved_gallery)[0]));
          const x=document.createElement('span');x.className='bx-x';x.setAttribute('aria-hidden','true');x.textContent='×';b.append(x);
          slotsNode.append(b);
        }else{
          const free=i>=o.paid;
          const s=document.createElement('span');s.className='bx-slot is-empty'+(free?' is-free':'');
          s.textContent=free?'FREE':'+';s.setAttribute('aria-hidden','true');slotsNode.append(s);
        }
      }
    };
    const renderTiers=()=>{
      root.querySelectorAll('[data-brellano-offer]').forEach(card=>{
        const key=card.dataset.brellanoOffer,on=key===offer;
        card.classList.toggle('is-active',on);card.setAttribute('aria-pressed',String(on));
        const price=card.querySelector('[data-bx-tier-price]'),was=card.querySelector('[data-bx-tier-was]'),meta=card.querySelector('[data-bx-tier-meta]');
        const t=key==='single'?(unitPrice(variant)??basePrice):total(key);
        if(price)price.textContent=money(t);
        if(was)was.textContent=key==='single'?money(comparePrice(variant)):money(fullPrice(key));
        if(meta){
          if(key==='single')meta.textContent='1 plush · '+shipText();
          else{meta.replaceChildren(document.createTextNode(OFFERS[key].qty+' plush · '+money(basePrice==null?null:round(total(key)/OFFERS[key].qty))+' each · '));const em=document.createElement('em');em.textContent='Free shipping';meta.append(em);}
        }
      });
    };
    const renderCta=()=>{
      const o=target(),count=isBundle()?picked().length:1,t=total(offer);
      let main,sub='',ready;
      if(!isBundle()){ready=buyable({family:family.key,color:variant.key});main=ready?'Add to cart':'Sold out';sub=ready?money(t):'';}
      else{
        const left=o.qty-count;ready=left===0&&picked().every(buyable)&&catalog.checkout_policy?.bundle_discounts_active===true;
        if(left===0){main='Add '+o.qty+' to cart';sub=money(t);}
        else{
          const freeLeft=Math.min(left,o.qty-o.paid);
          main=left===freeLeft?(left===1?'Pick your free one':'Pick your '+left+' free ones'):'Pick '+left+' more';
          sub=money(t);
        }
      }
      buy.disabled=root.dataset.cartBusy==='true'||(!isBundle()&&!ready);
      buy.dataset.bxReady=String(!!ready);
      buy.replaceChildren();const m=document.createElement('span');m.className='bx-cta-main';m.textContent=main;buy.append(m);
      if(sub){const s=document.createElement('span');s.className='bx-cta-sub';s.textContent=sub;buy.append(s);}
      const bar=q('.mobile-preview-bar');
      if(bar&&basePrice!=null){const s=bar.querySelector('[data-bx-sticky-sub]');if(s)s.textContent='Only '+money(round(total('trio')/3))+' each';}
    };
    const renderPrice=()=>{
      const price=q('[data-brellano-family-price]');price.textContent=!isBundle()&&!buyable({family:family.key,color:variant.key})?'Sold out':money(unitPrice(variant)??basePrice);
      const cmp=q('[data-bx-compare]'),off=q('[data-bx-off]'),now=unitPrice(variant),was=comparePrice(variant);
      if(cmp){cmp.hidden=!was;cmp.textContent=was?money(was):'';}
      if(off){off.hidden=!was;off.textContent=was?Math.round((1-now/was)*100)+'% OFF':'';}
      const each=q('[data-bx-each]');if(each){each.textContent=basePrice==null?'':'or '+money(round(total('trio')/3))+' each when you get 3';}
      const stock=q('[data-bx-stock]');if(stock)stock.hidden=!family.limited_stock_reported;
    };
    const render=()=>{renderPrice();renderTiers();renderSlots();renderRail();renderCta();};
    const renderFamily=()=>{
      q('[data-brellano-family-title]').textContent=family.product_title;
      root.querySelectorAll('[data-brellano-family]').forEach(b=>{const on=b.dataset.brellanoFamily===family.key;b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',String(on));});
      const specs=q('[data-brellano-family-specs]');
      if(specs)specs.textContent=family.key==='monster'&&variant.key==='white'?'White Monster: approx. 22 cm seated height · 15 cm span · 125 g':'Size information unavailable for this color.';
      if(!galleryReady&&q('#BrellanoGallery')?.querySelectorAll('.brellano-gallery-slide').length===allMedia.length&&q('.gallery-thumbnails')?.children.length===allMedia.length)galleryReady=true;
      if(!galleryReady){
        ['#BrellanoGallery','.zoom-photo-stage'].forEach(sel=>{const stage=q(sel);if(!stage)return;stage.replaceChildren();allMedia.forEach((item,i)=>{const slide=document.createElement('div');slide.className='brellano-gallery-slide';slide.dataset.brellanoSlide=String(i);slide.hidden=i!==0;const p=img(item,sel==='#BrellanoGallery'?800:1000);if(sel==='#BrellanoGallery'){p.srcset=[400,600,800].map(w=>bxW(item.src,w)+' '+w+'w').join(', ');p.sizes='(min-width: 761px) 46vw, 92vw';}p.className='approved-photo family-gallery-photo';p.loading=i?'lazy':'eager';slide.append(p);stage.append(slide);});});
        const thumbs=q('.gallery-thumbnails');if(thumbs){thumbs.replaceChildren();thumbs.hidden=allMedia.length<2;allMedia.forEach((item,i)=>{const b=document.createElement('button');b.type='button';b.className='thumbnail'+(i?'':' is-active');b.dataset.brellanoGallery=String(i);b.setAttribute('aria-pressed',String(!i));b.setAttribute('aria-controls','BrellanoGallery');b.setAttribute('aria-label','View '+item.alt);const p=img(item,160);p.className='family-thumbnail';b.append(p);thumbs.append(b);});}
        galleryReady=true;
      }
      const shown=(variant.approved_gallery||family.approved_gallery)[0];
      root.dispatchEvent(new CustomEvent('brellano:gallery-reset',{detail:{index:Math.max(0,allMedia.findIndex(item=>item.src===shown.src))}}));
      render();
    };
    const nudge=()=>{
      const box=q('[data-brellano-color-picker]');
      box.scrollIntoView({behavior:reduceMotion()?'auto':'smooth',block:'center'});
      box.classList.remove('bx-nudge');void box.offsetWidth;box.classList.add('bx-nudge');
      rail.querySelector('button:not(:disabled)')?.focus({preventScroll:true});
    };
    const buySelection=()=>{
      if(root.dataset.cartBusy==='true')return;
      let choices;
      if(isBundle()){if(picked().length!==target().qty||!picked().every(buyable)){nudge();return;}choices=picked();}
      else{const c={family:family.key,color:variant.key};if(!buyable(c))return;choices=[c];}
      const groups=new Map();choices.forEach(c=>{const id=Number(details(c).variant.variant_id);groups.set(id,(groups.get(id)||0)+1);});
      root.dispatchEvent(new CustomEvent('brellano:add-selection',{detail:{items:[...groups].map(([id,quantity])=>({id,quantity})),button:buy}}));
    };
    root.addEventListener('brellano:cart-idle',render);
    /* Sticky bar (phones): takes the shopper back up to the deal tiers instead of adding to the bag. */
    const stickyCans=root.querySelector('[data-bx-sticky-cans]');
    if(stickyCans&&!stickyCans.childElementCount)[...root.querySelectorAll('.family-card img')].slice(0,3).forEach(im=>{const c=document.createElement('img');c.src=im.getAttribute('src');c.alt='';c.width=60;c.height=76;c.loading='lazy';c.decoding='async';stickyCans.append(c);});
    root.querySelector('[data-bx-sticky]')?.addEventListener('click',()=>{const deal=root.querySelector('.bx-deal');if(!deal)return;deal.scrollIntoView({behavior:reduceMotion()?'auto':'smooth',block:'start'});deal.classList.remove('bx-flash');void deal.offsetWidth;deal.classList.add('bx-flash');setTimeout(()=>deal.classList.remove('bx-flash'),1800);});
    root.addEventListener('click',event=>{
      const b=event.target.closest('button');if(!b||b.disabled||!root.contains(b))return;
      if(b.dataset.brellanoColorDirection){rail.scrollBy({left:Number(b.dataset.brellanoColorDirection)*Math.max(72,rail.clientWidth-72),behavior:reduceMotion()?'auto':'smooth'});return;}
      if(b.dataset.brellanoFamily){const next=famOf(b.dataset.brellanoFamily);if(!next)return;family=next;variant=next.variants.find(v=>v.key===remembered.get(next.key))||firstBuyable(next)||next.variants[0];renderFamily();return;}
      if(b.dataset.brellanoColor&&b.closest('[data-brellano-color-options]')){
        const v=family.variants.find(x=>x.key===b.dataset.brellanoColor);if(!v)return;
        variant=v;remembered.set(family.key,v.key);
        if(isBundle()){
          const empty=slots.slice(0,target().qty).findIndex(c=>!c);
          if(empty>=0&&buyable({family:family.key,color:v.key})){slots[empty]={family:family.key,color:v.key};status.textContent=v.label+' '+family.label+' added. '+picked().length+' of '+target().qty+' picked.';}
          else if(empty<0){status.textContent='Your crew is full. Remove one to swap it.';const top=q('.bx-crew-top');top?.classList.remove('bx-nudge');void top?.offsetWidth;top?.classList.add('bx-nudge');}
        }
        renderFamily();
        rail.querySelector('[data-brellano-color="'+v.key+'"]')?.focus({preventScroll:true});
        return;
      }
      if(b.dataset.brellanoOffer){
        const prev=offer;offer=b.dataset.brellanoOffer;
        if(isBundle()&&!slots.some(Boolean)&&buyable({family:family.key,color:variant.key}))slots[0]={family:family.key,color:variant.key};
        if(prev==='crew'&&offer==='trio')slots.fill(null,3);
        render();
        status.textContent=isBundle()?picked().length+' of '+target().qty+' picked.':'One plush selected.';
        return;
      }
      if(b.dataset.bxRemove!==undefined){slots[Number(b.dataset.bxRemove)]=null;compact();render();(slotsNode.querySelector('button')||rail.querySelector('button:not(:disabled)'))?.focus({preventScroll:true});return;}
      if(b.hasAttribute('data-brellano-family-buy'))buySelection();
    });
    root.addEventListener('keydown',event=>{const b=event.target.closest('[data-brellano-color]');if(!b||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;const list=[...rail.querySelectorAll('[data-brellano-color]:not(:disabled)')],i=list.indexOf(b),n=event.key==='Home'?0:event.key==='End'?list.length-1:Math.max(0,Math.min(list.length-1,i+(event.key==='ArrowLeft'?-1:1)));event.preventDefault();list[n]?.focus({preventScroll:true});});
    renderFamily();
  };
  document.querySelectorAll('[data-brellano-draft]').forEach(initBuyBox);
  document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-brellano-draft]');if(root)initBuyBox(root);});
})();

(() => {
  const init=root=>{
    const strip=root.querySelector('.mood-strip'),toggle=strip?.querySelector('.mood-toggle');
    if(!toggle||strip.dataset.motionInitialized)return;
    strip.dataset.motionInitialized='true';
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let manual=false,hover=false,focused=false,offscreen=false,ignoreInteraction=false;
    const track=strip.querySelector('.mood-track'),group=strip.querySelector('.mood-group');
    const speed=()=>{track.style.animationDuration=Math.max(1,group.getBoundingClientRect().width/30)+'s';};
    const update=()=>{if(!hover&&!focused)ignoreInteraction=false;const paused=manual||(!ignoreInteraction&&(hover||focused))||offscreen||motion.matches||document.hidden;strip.dataset.motionPaused=String(paused);toggle.disabled=motion.matches;toggle.setAttribute('aria-pressed',String(manual||motion.matches));toggle.setAttribute('aria-label',motion.matches?'Scrolling text paused for reduced motion':manual?'Resume scrolling text':'Pause scrolling text');toggle.querySelector('use').setAttribute('href','#brellano-icon-'+(manual||motion.matches?'play':'pause'));};
    toggle.addEventListener('click',()=>{manual=!manual;ignoreInteraction=!manual;update();});
    strip.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hover=true;update();}});
    strip.addEventListener('pointerleave',()=>{hover=false;update();});
    strip.addEventListener('focusin',()=>{focused=true;update();});
    strip.addEventListener('focusout',event=>{if(!strip.contains(event.relatedTarget)){focused=false;update();}});
    const visibility=new IntersectionObserver(entries=>{offscreen=!entries[0].isIntersecting;update();});visibility.observe(strip);
    const size=new ResizeObserver(speed);size.observe(group);speed();
    motion.addEventListener('change',update);document.addEventListener('visibilitychange',update);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){motion.removeEventListener('change',update);document.removeEventListener('visibilitychange',update);visibility.disconnect();size.disconnect();}});
    const sticky=root.querySelector('.mobile-preview-bar'),buy=root.querySelector('[data-brellano-family-buy]');
    const stickyUpdate=()=>{if(sticky)sticky.hidden=window.innerWidth>760||buy.getBoundingClientRect().bottom>=0||!!root.querySelector('dialog[open]');};
    window.addEventListener('scroll',stickyUpdate,{passive:true});window.addEventListener('resize',stickyUpdate,{passive:true});
    const dialogs=new MutationObserver(stickyUpdate);dialogs.observe(root,{subtree:true,attributes:true,attributeFilter:['open']});stickyUpdate();
    const collection=root.querySelector('.collection-grid'),collectionButtons=root.querySelectorAll('[data-brellano-collection-direction]');
    const collectionUpdate=()=>collectionButtons.forEach(button=>{button.disabled=Number(button.dataset.brellanoCollectionDirection)<0?collection.scrollLeft<=1:collection.scrollLeft+collection.clientWidth>=collection.scrollWidth-1;});
    collectionButtons.forEach(button=>button.addEventListener('click',()=>collection.scrollBy({left:Number(button.dataset.brellanoCollectionDirection)*(collection.querySelector('.collection-card').getBoundingClientRect().width+14),behavior:motion.matches?'auto':'smooth'})));
    collection.addEventListener('scroll',collectionUpdate,{passive:true});window.addEventListener('resize',collectionUpdate,{passive:true});collectionUpdate();
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){window.removeEventListener('scroll',stickyUpdate);window.removeEventListener('resize',stickyUpdate);window.removeEventListener('resize',collectionUpdate);dialogs.disconnect();}});
    root.querySelector('[data-brellano-shipping]')?.addEventListener('click',event=>{event.preventDefault();const faq=root.querySelector('#shipping-returns');faq.open=true;faq.scrollIntoView({behavior:motion.matches?'auto':'smooth',block:'start'});faq.querySelector('summary').focus({preventScroll:true});});
    update();
  };
  document.querySelectorAll('[data-brellano-draft]').forEach(init);
  document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-brellano-draft]');if(root)init(root);});
})();

(() => {
 /* Bag drawer: progress toward the free plush (1 → 3 → 6), pick-your-free-one rail,
    one card per color, and a plain receipt (subtotal, deal, shipping, total). */
 const SHIP_USD=4.61,FREE_SHIP_USD=55;
 const init=root=>{
  const bag=root.querySelector('#BrellanoBag');if(!bag||root.dataset.liveCartInitialized)return;root.dataset.liveCartInitialized='true';
  const catalog=JSON.parse(root.querySelector('[data-brellano-family-catalog]').textContent);
  const variants=new Map(catalog.families.flatMap(f=>f.variants.map(v=>[String(v.variant_id),{family:f,variant:v}])));
  const base=window.Shopify?.routes?.root||'/';
  const $=sel=>bag.querySelector(sel);
  const itemsNode=$('[data-brellano-cart-items]'),errorNode=$('[data-brellano-cart-error]'),checkout=$('[data-brellano-checkout]');
  const rate=()=>Number(window.Shopify?.currency?.rate)||1;
  let cart=null,busy=false,returnTarget=null;
  const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:cart?.currency||'USD'}).format(Number(cents||0)/100);
  const eligible=item=>{const m=variants.get(String(item.variant_id));return !!m&&m.variant.bundle_selectable!==false;};
  const nameOf=item=>{const m=variants.get(String(item.variant_id));return m?m.variant.label+' '+m.family.label:(item.product_title||item.title);};
  const subOf=item=>{const m=variants.get(String(item.variant_id));return m?'Can plush':(item.variant_title||'');};
  const imageOf=item=>{const m=variants.get(String(item.variant_id));return m?(m.variant.approved_gallery||m.family.approved_gallery)[0].src:(item.featured_image?.url||item.image||'');};
  const request=async(path,body)=>{const r=await fetch(base+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{cache:'no-store'})});const result=await r.json();if(!r.ok)throw new Error(result.description||result.message||'Your bag could not be updated. Please try again.');return result;};
  const announce=text=>{$('[data-brellano-cart-status]').textContent=text;const s=root.querySelector('[data-brellano-family-status]');if(s)s.textContent=text;};
  const groups=()=>{const map=new Map();cart.items.forEach(item=>{const k=String(item.variant_id);const g=map.get(k)||{variant_id:item.variant_id,keys:[],quantity:0,final:0,original:0,first:item};g.keys.push(item.key);g.quantity+=item.quantity;g.final+=Number(item.final_line_price);g.original+=Number(item.original_line_price??item.original_price*item.quantity);map.set(k,g);});return [...map.values()];};
  const savings=()=>{
   const out={bundle:0,code:0,other:0,bundleTitle:''};
   const titles=new Set(['Buy 2 get 1 free','Buy 4, get 2 free','BRELLANO Buy 2, Get 1 Free','BRELLANO Buy 4, Get 2 Free']);
   const allocs=[...(cart.cart_level_discount_applications||[]).map(a=>({amount:a.total_allocated_amount,app:a})),...cart.items.flatMap(i=>(i.line_level_discount_allocations||[]).map(a=>({amount:a.amount,app:a.discount_application})))];
   allocs.forEach(({amount,app})=>{const c=Number(amount);if(!(c>0))return;const kind=app?.type==='discount_code'?'code':titles.has(app?.title)?'bundle':'other';out[kind]+=c;if(kind==='bundle')out.bundleTitle=app.title;});
   return out;
  };
  const shipping=()=>{
   const free=Number(cart.total_price)/100>=FREE_SHIP_USD*rate()-0.005;
   if(free)return {free:true,cents:0,text:'Free'};
   if((cart.currency||'USD')==='USD')return {free:false,cents:Math.round(SHIP_USD*100),text:money(SHIP_USD*100)};
   return {free:false,cents:0,text:'At checkout'};
  };
  const meterCopy=(n,saved)=>{
   if(n===0)return '';
   if(n===1)return '<b>Add 1 more and get 1 free.</b> Shipping goes free too.';
   if(n===2)return '<b>You unlocked 1 free plush!</b> Pick it below. Shipping is free.';
   if(n===3)return '<b>Buy 2, get 1 free is on.</b> You saved '+saved+'. Add 2 more to unlock Buy 4, get 2 free.';
   if(n===4)return '<b>Add 1 more</b> and your 2nd free one unlocks.';
   if(n===5)return '<b>Buy 4, get 2 free unlocked!</b> Pick your 2nd free one below.';
   if(n===6)return '<b>Buy 4, get 2 free is on.</b> You saved '+saved+'.';
   const r=n%3;
   if(r===0)return '<b>'+(n/3*2)+' paid, '+(n/3)+' free.</b> You saved '+saved+'.';
   if(r===2)return '<b>Your next one is free.</b> Pick it below.';
   return '<b>Add 1 more</b> and the next one is free.';
  };
  /* Meter: checkpoints are what you pay for (2 and 4). A checkpoint glows when its free plush is unlocked and stays lit once it is in the bag. */
  const meterFill=n=>Math.min(n-Math.floor(n/3),4)/4*100;
  const pickTitle=n=>{if(n===1)return 'Add 1 more, get 1 free';if(n===2)return 'Pick your free one';if(n===3)return 'Level up: Buy 4, get 2 free';if(n===4)return 'Add 1 more, get another free';if(n===5)return 'Pick your 2nd free one';return '';};
  const renderPick=n=>{
   const box=$('[data-bx-pick]'),title=pickTitle(n);
   box.hidden=!title||n>=6;if(box.hidden)return;
   $('[data-bx-pick-title]').textContent=title;
   const list=$('[data-bx-pick-rail]');list.replaceChildren();
   const inCart=new Set(cart.items.map(i=>String(i.variant_id)));
   const options=catalog.families.flatMap(f=>f.variants.filter(v=>v.available===true&&!v.sold_out&&v.bundle_selectable!==false).map(v=>({f,v})));
   options.sort((a,b)=>Number(inCart.has(String(a.v.variant_id)))-Number(inCart.has(String(b.v.variant_id))));
   options.forEach(({f,v})=>{
    const b=document.createElement('button');b.type='button';b.className='bx-pick-item';b.dataset.bxAdd=String(v.variant_id);
    b.setAttribute('aria-label','Add '+v.label+' '+f.label+(n%3===2?', free':''));
    const pic=document.createElement('span');pic.className='bx-pick-img';const im=document.createElement('img');im.src=String((v.approved_gallery||f.approved_gallery)[0].src).replace(/([?&])width=\d+/,'$1width=200');im.alt='';im.loading='lazy';im.width=800;im.height=1000;pic.append(im);
    const plus=document.createElement('i');plus.textContent='+';plus.setAttribute('aria-hidden','true');pic.append(plus);
    const name=document.createElement('span');name.className='bx-pick-name';name.textContent=v.label;
    const fam=document.createElement('small');fam.textContent=f.label;
    b.append(pic,name,fam);list.append(b);
   });
  };
  const render=next=>{
   cart=next;itemsNode.replaceChildren();
   const n=cart.items.filter(eligible).reduce((s,i)=>s+i.quantity,0),save=savings(),ship=shipping();
   groups().forEach(g=>{
    const row=document.createElement('article');row.className='bx-line';row.dataset.cartKey=g.keys[0];row.dataset.cartKeys=g.keys.join(',');row.dataset.quantity=String(g.quantity);
    const pic=document.createElement('div');pic.className='bx-line-img';const im=document.createElement('img');im.src=String(imageOf(g.first)).replace(/([?&])width=\d+/,'$1width=200');im.alt='';im.loading='lazy';im.width=800;im.height=1000;pic.append(im);
    const info=document.createElement('div');info.className='bx-line-info';
    const nm=document.createElement('p');nm.className='bx-line-name';nm.textContent=nameOf(g.first);
    const sub=document.createElement('p');sub.className='bx-line-sub';sub.textContent=subOf(g.first);
    const qty=document.createElement('div');qty.className='bx-qty';
    const minus=document.createElement('button');minus.type='button';minus.dataset.brellanoCartAction='decrease';minus.textContent='−';minus.disabled=busy||g.quantity<=1;minus.setAttribute('aria-label','Remove one '+nameOf(g.first));
    const amount=document.createElement('span');amount.textContent=String(g.quantity);amount.setAttribute('aria-label','Quantity '+g.quantity);
    const plus=document.createElement('button');plus.type='button';plus.dataset.brellanoCartAction='increase';plus.textContent='+';plus.disabled=busy;plus.setAttribute('aria-label','Add one '+nameOf(g.first));
    qty.append(minus,amount,plus);info.append(nm,sub,qty);
    const price=document.createElement('div');price.className='bx-line-price';
    if(g.final===0&&g.original>0){const pill=document.createElement('span');pill.className='bx-free';pill.textContent='FREE';const s=document.createElement('s');s.textContent=money(g.original);price.append(pill,s);}
    else{const now=document.createElement('strong');now.textContent=money(g.final);price.append(now);if(g.final<g.original){const s=document.createElement('s');s.textContent=money(g.original);price.append(s);const unit=g.original/g.quantity,free=Math.floor((g.original-g.final)/unit+0.001);const pill=document.createElement('span');pill.className='bx-free';pill.textContent=free>0?free+' FREE':'DEAL';price.append(pill);}}
    const rm=document.createElement('button');rm.type='button';rm.className='bx-remove';rm.dataset.brellanoCartAction='remove';rm.textContent='Remove';rm.disabled=busy;rm.setAttribute('aria-label','Remove '+nameOf(g.first));price.append(rm);
    row.append(pic,info,price);itemsNode.append(row);
   });
   const empty=cart.item_count===0;
   root.querySelectorAll('[data-brellano-bag-count]').forEach(node=>node.textContent=String(cart.item_count));
   root.querySelectorAll('[data-brellano-open="BrellanoBag"]').forEach(node=>node.setAttribute('aria-label','Open your bag, '+cart.item_count+' items'));
   $('[data-brellano-cart-empty]').hidden=!empty;itemsNode.hidden=empty;$('[data-brellano-cart-footer]').hidden=empty;
   const meter=$('[data-bx-meter]');meter.hidden=empty||n===0;
   if(!meter.hidden){
    $('[data-bx-meter-text]').innerHTML=meterCopy(n,money(save.bundle));
    $('[data-bx-fill]').style.width=meterFill(n)+'%';
    bag.querySelectorAll('[data-bx-cp]').forEach(cp=>{const k=Number(cp.dataset.bxCp);cp.classList.toggle('is-done',n>=3*k);cp.classList.toggle('is-ready',n===3*k-1);});
   }
   if(empty)$('[data-bx-pick]').hidden=true;else renderPick(n);
   const original=Number(cart.original_total_price??cart.items.reduce((s,i)=>s+Number(i.original_line_price),0));
   $('[data-bx-sub-label]').textContent='Subtotal ('+cart.item_count+')';
   $('[data-bx-sub]').textContent=money(original);
   const saveRow=$('[data-bx-save-row]');saveRow.hidden=!save.bundle;
   $('[data-bx-save-label]').textContent=/buy 4/i.test(save.bundleTitle)?'Buy 4, get 2 free':'Buy 2, get 1 free';
   $('[data-bx-save]').textContent='−'+money(save.bundle);
   const codeRow=$('[data-bx-code-row]');codeRow.hidden=!(save.code+save.other);$('[data-bx-code]').textContent='−'+money(save.code+save.other);
   const shipNode=$('[data-bx-ship]');shipNode.textContent=ship.text;shipNode.classList.toggle('is-free',ship.free);
   const totalCents=Number(cart.total_price)+ship.cents;
   $('[data-brellano-cart-subtotal]').textContent=money(totalCents);
   checkout.textContent=empty?'Checkout':'Checkout · '+money(totalCents);
   checkout.disabled=empty||busy;
  };
  const setBusy=(value,adding=false)=>{
   busy=value;root.dataset.cartBusy=String(value);bag.setAttribute('aria-busy',String(value));
   root.querySelectorAll('[data-brellano-family-buy]').forEach(b=>{if(value){b.disabled=true;b.classList.add('is-loading');if(adding){b.dataset.idleHtml=b.innerHTML;b.textContent='Adding…';}}else{b.classList.remove('is-loading');if(b.dataset.idleHtml!==undefined){b.innerHTML=b.dataset.idleHtml;delete b.dataset.idleHtml;}}});
   bag.querySelectorAll('[data-brellano-cart-action],[data-bx-add],[data-brellano-checkout]').forEach(b=>b.disabled=value);
   if(!value){root.dispatchEvent(new CustomEvent('brellano:cart-idle'));if(cart)render(cart);}
  };
  const fail=error=>{errorNode.textContent=error.message;errorNode.hidden=false;const main=root.querySelector('[data-brellano-purchase-error]');if(main){main.textContent=error.message;main.hidden=false;}announce(error.message);};
  const open=target=>{returnTarget=target||returnTarget;if(!bag.open)bag.showModal();document.body.classList.add('brellano-dialog-open');bag.querySelector('[data-brellano-close]').focus({preventScroll:true});};
  root.addEventListener('brellano:add-selection',async event=>{
   if(busy)return;const {items,button}=event.detail;
   if(!Array.isArray(items)||!items.length||items.some(i=>!variants.get(String(i.id))?.variant.available||variants.get(String(i.id))?.variant.sold_out||!Number.isInteger(i.quantity)||i.quantity<1)){announce('This selection is unavailable.');return;}
   errorNode.hidden=true;const main=root.querySelector('[data-brellano-purchase-error]');if(main)main.hidden=true;
   setBusy(true,true);announce('Adding to your bag…');
   try{await request('cart/add.js',{items});cart=await request('cart.js');root.dispatchEvent(new CustomEvent('brellano:cart-added'));open(button);announce('Added to your bag. '+cart.item_count+' items.');}
   catch(error){fail(error);try{cart=await request('cart.js');}catch{}}
   finally{setBusy(false);}
  });
  root.querySelectorAll('[data-brellano-open="BrellanoBag"]').forEach(b=>b.addEventListener('click',async()=>{returnTarget=b;errorNode.hidden=true;try{render(await request('cart.js'));}catch(error){fail(error);}}));
  bag.addEventListener('close',()=>{if(returnTarget?.isConnected)returnTarget.focus({preventScroll:true});});
  const setGroup=async(row,quantity,action)=>{
   if(busy||!cart)return;const keys=row.dataset.cartKeys.split(','),updates={};keys.forEach((k,i)=>{updates[k]=i===0?quantity:0;});
   const variantId=cart.items.find(i=>i.key===keys[0])?.variant_id;errorNode.hidden=true;setBusy(true);
   try{cart=await request('cart/update.js',{updates});announce('Your bag was updated.');}
   catch(error){fail(error);try{cart=await request('cart.js');}catch{}}
   finally{setBusy(false);const next=[...itemsNode.children].find(node=>cart.items.some(i=>i.key===node.dataset.cartKey&&i.variant_id===variantId));const control=next?.querySelector('[data-brellano-cart-action="'+action+'"]');(control&&!control.disabled?control:bag.querySelector('[data-brellano-close]'))?.focus({preventScroll:true});}
  };
  itemsNode.addEventListener('click',event=>{const b=event.target.closest('button[data-brellano-cart-action]');if(!b||busy)return;const row=b.closest('.bx-line'),q=Number(row.dataset.quantity),a=b.dataset.brellanoCartAction;setGroup(row,a==='remove'?0:q+(a==='increase'?1:-1),a);});
  $('[data-bx-pick-rail]').addEventListener('click',async event=>{const b=event.target.closest('[data-bx-add]');if(!b||busy)return;errorNode.hidden=true;setBusy(true);try{await request('cart/add.js',{items:[{id:Number(b.dataset.bxAdd),quantity:1}]});cart=await request('cart.js');announce('Added to your bag. '+cart.item_count+' items.');}catch(error){fail(error);try{cart=await request('cart.js');}catch{}}finally{setBusy(false);$('[data-bx-pick-rail] button')?.focus({preventScroll:true});}});
  checkout.addEventListener('click',()=>{if(!busy&&cart?.item_count)window.location.assign(base+'checkout');});
  const params=new URLSearchParams(window.location.search);
  if(params.get('bag')==='open'){
   params.delete('bag');history.replaceState(null,'',window.location.pathname+(params.toString()?'?'+params:'')+window.location.hash);
   request('cart.js').then(next=>{render(next);open(null);}).catch(fail);
  }else request('cart.js').then(render).catch(fail);
 };
 document.querySelectorAll('[data-brellano-draft]').forEach(init);document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-brellano-draft]');if(root)init(root);});
})();

(() => {
  const main=()=>document.querySelector('[data-brellano-draft]');
  const focusTarget=target=>{
    if(target.tagName==='DETAILS')target.open=true;
    const heading=target.tagName==='DETAILS'?target.querySelector('summary'):target.querySelector('h1,h2')||target;
    if(!heading.matches('summary'))heading.setAttribute('tabindex','-1');
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    heading.focus({preventScroll:true});
  };
  const afterMenuClose=(root,action)=>{
    const menu=root.querySelector('#BrellanoMenu');
    if(menu?.open){menu.addEventListener('close',()=>requestAnimationFrame(action),{once:true});menu.close();}
    else requestAnimationFrame(action);
  };
  const selectFamily=(root,key)=>{
    const button=[...root.querySelectorAll('[data-brellano-family-picker] [data-brellano-family]')].find(item=>item.dataset.brellanoFamily===key);
    if(!button||button.disabled)return false;
    afterMenuClose(root,()=>{button.click();focusTarget(root.querySelector('#brellano-main'));});
    return true;
  };
  const refresh=()=>{
    document.querySelectorAll('[data-brellano-navigation-year]').forEach(item=>{item.textContent=String(new Date().getFullYear());});
    const root=main(),key=new URL(window.location.href).searchParams.get('can');
    if(root&&key&&!root.dataset.brellanoNavigationInitialFamily){root.dataset.brellanoNavigationInitialFamily='true';selectFamily(root,key);}
  };
  if(!document.documentElement.dataset.brellanoNavigationBound){
    document.documentElement.dataset.brellanoNavigationBound='true';
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[data-brellano-navigation-family],a[data-brellano-navigation-target],a[data-brellano-navigation-contact],a[data-brellano-navigation-external]');
      if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const root=main();if(!root)return;
      if(link.hasAttribute('data-brellano-navigation-family')){if(selectFamily(root,link.dataset.brellanoNavigationFamily))event.preventDefault();return;}
      if(link.hasAttribute('data-brellano-navigation-target')){const target=document.getElementById(link.dataset.brellanoNavigationTarget.slice(1));if(!target)return;event.preventDefault();afterMenuClose(root,()=>focusTarget(target));return;}
      root.querySelector('#BrellanoMenu')?.close();
    });
    document.addEventListener('shopify:section:load',refresh);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})();

(() => {
 if(window.Shopify?.designMode)return;
 if(document.documentElement.dataset.brellanoPhotoOrderBound)return;
 document.documentElement.dataset.brellanoPhotoOrderBound='true';
 /* Storefront order just above the collection cards: photo strip, then reviews (sections/brellano-reviews.liquid). */
 const place=()=>{const collection=document.querySelector('[data-brellano-draft] #collection');if(!collection)return;let ref=collection;[document.querySelector('.shopify-section.brellano-reviews-section'),document.querySelector('.shopify-section.brellano-photo-strip-section')].forEach(el=>{if(!el)return;if(ref.previousElementSibling!==el)ref.before(el);ref=el;});};
 document.addEventListener('shopify:section:load',()=>requestAnimationFrame(place));
 document.addEventListener('shopify:section:unload',event=>{['.shopify-section.brellano-reviews-section','.shopify-section.brellano-photo-strip-section'].forEach(sel=>{const own=event.target.querySelector(sel);if(own)event.target.after(own);});});
 place();
})();

(() => {
 const init=root=>{
  if(root.dataset.brellanoRefreshInitialized)return;
  root.dataset.brellanoRefreshInitialized='true';
  const viewport=window.visualViewport;
  const syncViewport=()=>root.style.setProperty('--brellano-dialog-height',(viewport?.height||window.innerHeight)+'px');
  syncViewport();window.addEventListener('resize',syncViewport,{passive:true});viewport?.addEventListener('resize',syncViewport,{passive:true});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){window.removeEventListener('resize',syncViewport);viewport?.removeEventListener('resize',syncViewport);}});
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(!('IntersectionObserver' in window)||motion.matches||window.Shopify?.designMode)return;
  const sections=[...root.querySelectorAll('.collection-section,.gifting-section,.details-section,.faq-section')];
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('is-reveal-pending');observer.unobserve(entry.target);}}),{threshold:.08});
  sections.forEach(section=>{section.classList.add('brellano-reveal');if(section.getBoundingClientRect().top>window.innerHeight){section.classList.add('is-reveal-pending');observer.observe(section);}});
  const clear=()=>{if(motion.matches){sections.forEach(section=>section.classList.remove('is-reveal-pending'));observer.disconnect();}};
  motion.addEventListener('change',clear);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer.disconnect();motion.removeEventListener('change',clear);}});
 };
 document.querySelectorAll('[data-brellano-draft]').forEach(init);
 document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-brellano-draft]');if(root)init(root);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brellano-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.bxtReady) return;
    root.dataset.bxtReady = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* Thumbnails: the same product photos the buy box already loaded (catalog JSON in the shell). */
    try {
      const src = document.querySelector('[data-brellano-family-catalog]');
      const catalog = src ? JSON.parse(src.textContent) : null;
      root.querySelectorAll('[data-bxt-thumb]').forEach(el => {
        const [fam, col] = el.dataset.bxtThumb.split('/');
        const f = catalog?.families?.find(x => x.key === fam);
        const v = f?.variants?.find(x => x.key === col);
        const img = ((v && v.approved_gallery) || (f && f.approved_gallery) || [])[0];
        if (img && img.src) el.style.backgroundImage = 'url("' + String(img.src).replace(/([?&])width=\d+/, '$1width=120') + '")';
        else el.remove();
      });
    } catch (e) {}
    const rail = root.querySelector('[data-bxt-rail]');
    const dots = [...root.querySelectorAll('[data-bxt-dots] i')];
    if (rail && dots.length) {
      const cards = [...rail.querySelectorAll('.bxt-card:not(.bxt-card--empty)')];
      let raf = 0;
      const sync = () => {
        raf = 0;
        const mid = rail.getBoundingClientRect().left + rail.clientWidth / 2;
        let best = 0, dist = Infinity;
        cards.forEach((c, i) => { const r = c.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); if (d < dist) { dist = d; best = i; } });
        dots.forEach((d, i) => d.classList.toggle('is-on', i === best));
      };
      rail.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, {passive: true});
    }
    root.querySelector('[data-bxt-cta]')?.addEventListener('click', () => {
      const shell = document.querySelector('[data-brellano-draft]') || document;
      shell.querySelector('[data-brellano-offer="trio"]')?.click();
      (shell.querySelector('.bx-deal') || document.getElementById('brellano-main') || shell).scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'start'});
    });
  };
  const all = () => document.querySelectorAll('[data-bxt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all, {once: true}); else all();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-bxt]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brellano-video-reel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SEL = '.shopify-section.brellano-video-reel-section';
  const place = () => {
    if (window.Shopify?.designMode) return;
    const strip = document.querySelector('[data-brellano-draft] .mood-strip');
    document.querySelectorAll(SEL).forEach(sec => { if (strip && strip.previousElementSibling !== sec) strip.before(sec); });
  };
  document.addEventListener('shopify:section:unload', event => {
    const own = event.target.matches?.(SEL) ? null : event.target.querySelector(SEL);
    if (own) event.target.after(own);
  });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(place));

  const instances = new WeakMap();
  const init = root => {
    if (!root || instances.has(root)) return;
    const rail = root.querySelector('.bxv-rail');
    const orig = [...root.querySelectorAll('[data-bxv-card]')];
    const N = orig.length;
    if (!rail || !N) return;
    const desk = window.matchMedia('(min-width: 900px)');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const life = new AbortController();
    const on = (t, e, f, o = {}) => t.addEventListener(e, f, {...o, signal: life.signal});
    orig.forEach((c, i) => { c.dataset.bxvI = i; });
    const loop = N > 1 && !window.Shopify?.designMode;
    if (loop) {
      const copy = () => orig.map(c => {
        const k = c.cloneNode(true);
        k.removeAttribute('data-shopify-editor-block');
        k.setAttribute('aria-hidden', 'true');
        k.querySelectorAll('button').forEach(b => { b.tabIndex = -1; });
        return k;
      });
      rail.prepend(...copy());
      rail.append(...copy());
      root.classList.add('bxv--loop');
    }
    const cards = [...rail.querySelectorAll('[data-bxv-card]')];
    const posters = () => cards.forEach(c => { const v = c.querySelector('video'); if (v && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); });
    if ('IntersectionObserver' in window) { const po = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { posters(); po.disconnect(); } }, {rootMargin: '800px 0px'}); po.observe(root); } else posters();
    const vid = c => c.querySelector('video');
    const ratios = new Map(), hasIO = 'IntersectionObserver' in window;
    let inView = !hasIO, active = loop ? N : 0, soundEl = null;
    const manual = new Set();
    const autoplay = () => root.dataset.autoplay === 'true' && !motion.matches;
    const visible = i => !hasIO || (ratios.get(i) || 0) >= .55;
    const mid = c => c.offsetLeft + c.offsetWidth / 2;
    const goTo = (c, smooth) => rail.scrollTo({left: mid(c) - rail.clientWidth / 2, behavior: smooth && !motion.matches ? 'smooth' : 'auto'});
    const nearest = () => {
      const rc = rail.scrollLeft + rail.clientWidth / 2;
      let best = active, d = Infinity;
      cards.forEach((c, i) => { const x = Math.abs(mid(c) - rc); if (x < d) { d = x; best = i; } });
      return best;
    };
    const setSound = el => {
      soundEl = el;
      cards.forEach(c => {
        const v = vid(c), b = c.querySelector('[data-bxv-mute]'), lit = c === el;
        if (v) v.muted = !lit;
        if (b) { b.setAttribute('aria-pressed', String(lit)); b.setAttribute('aria-label', lit ? 'Turn sound off' : 'Turn sound on'); b.querySelector('[data-bxv-off]').toggleAttribute('hidden', lit); b.querySelector('[data-bxv-on]').toggleAttribute('hidden', !lit); }
      });
    };
    const play = c => { const v = vid(c); if (!v) return; if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); if (v.preload === 'none') v.preload = 'auto'; const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    const pause = c => { const v = vid(c); if (v && !v.paused) v.pause(); };
    const dots = [...root.querySelectorAll('.bxv-dots i')];
    const sync = () => {
      cards.forEach((c, i) => {
        const center = i === active;
        c.classList.toggle('is-center', center);
        c.classList.toggle('is-idle', !center);
        const want = inView && (manual.has(c) || (autoplay() && (desk.matches ? visible(i) : center)));
        if (want) play(c); else pause(c);
      });
      if (soundEl) {
        const si = cards.indexOf(soundEl);
        if (!inView || (desk.matches ? !visible(si) : si !== active)) setSound(null);
      }
      dots.forEach((d, i) => d.classList.toggle('on', i === active % N));
    };
    const recenter = () => {
      if (!loop) return;
      const shift = active < N ? N : active >= 2 * N ? -N : 0;
      if (!shift) return;
      const from = cards[active], to = cards[active + shift];
      const fv = vid(from), tv = vid(to);
      if (fv && tv && !fv.paused) { try { tv.currentTime = fv.currentTime; } catch (e) {} }
      const hadSound = soundEl === from, wasManual = manual.has(from);
      rail.classList.add('bxv-jump');
      rail.scrollLeft += mid(to) - mid(from);
      active += shift;
      if (wasManual) { manual.delete(from); manual.add(to); }
      if (hadSound) setSound(to);
      sync();
      requestAnimationFrame(() => requestAnimationFrame(() => rail.classList.remove('bxv-jump')));
    };
    let ticking = false, idle = 0;
    on(rail, 'scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; const n = nearest(); if (n !== active) { manual.forEach(c => { if (desk.matches ? false : c !== cards[n]) manual.delete(c); }); active = n; sync(); } }); }
      clearTimeout(idle); idle = setTimeout(recenter, 160);
    }, {passive: true});
    cards.forEach(c => {
      const v = vid(c), bar = c.querySelector('.bxv-bar i');
      if (!v) return;
      v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls'); v.removeAttribute('autoplay');
      on(v, 'play', () => c.classList.add('is-playing'));
      on(v, 'pause', () => c.classList.remove('is-playing'));
      on(v, 'timeupdate', () => { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100).toFixed(1) + '%'; });
    });
    on(rail, 'click', event => {
      const c = event.target.closest('[data-bxv-card]');
      if (!c || !c.querySelector('video')) return;
      const shopBtn = event.target.closest('.bxv-shop');
      if (shopBtn) { shop(shopBtn); return; }
      const i = cards.indexOf(c), v = vid(c);
      if (i !== active) { goTo(c, true); manual.add(c); setSound(c); play(c); return; }
      if (v.paused) { manual.add(c); setSound(c); play(c); return; }
      setSound(soundEl === c ? null : c);
    });
    const shop = btn => {
      const shell = document.querySelector('[data-brellano-draft]') || document;
      const fam = btn.dataset.bxvShopFamily, color = btn.dataset.bxvShopColor;
      const famBtn = shell.querySelector('.bx-famtabs [data-brellano-family="' + fam + '"]') || shell.querySelector('[data-brellano-family="' + fam + '"]');
      famBtn?.click();
      requestAnimationFrame(() => {
        shell.querySelector('[data-brellano-color-options] [data-brellano-color="' + color + '"]')?.click();
        (document.getElementById('brellano-main') || shell).scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'start'});
      });
    };
    const cta = root.querySelector('[data-bxv-cta]');
    if (cta) on(cta, 'click', () => {
      const shell = document.querySelector('[data-brellano-draft]') || document;
      shell.querySelector('[data-brellano-offer="trio"]')?.click();
      (shell.querySelector('[data-brellano-color-picker]') || document.getElementById('brellano-main') || shell).scrollIntoView({behavior: motion.matches ? 'auto' : 'smooth', block: 'center'});
    });
    const nav = root.querySelector('[data-bxv-nav]');
    if (nav) {
      const arrows = [...nav.querySelectorAll('[data-bxv-dir]')];
      const navSync = () => {
        if (loop) { nav.hidden = false; arrows.forEach(a => { a.disabled = false; }); return; }
        nav.hidden = rail.scrollWidth <= rail.clientWidth + 4;
        arrows[0].disabled = active <= 0; arrows[1].disabled = active >= cards.length - 1;
      };
      arrows.forEach(btn => on(btn, 'click', () => {
        const next = cards[Math.max(0, Math.min(cards.length - 1, active + Number(btn.dataset.bxvDir)))];
        if (next) goTo(next, true);
      }));
      on(rail, 'scroll', navSync, {passive: true});
      on(window, 'resize', navSync);
      navSync();
    }
    let raf = 0;
    on(window, 'resize', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { rail.classList.add('bxv-jump'); goTo(cards[active], false); requestAnimationFrame(() => rail.classList.remove('bxv-jump')); }); });
    let railObs = null, viewObs = null;
    if (hasIO) {
      railObs = new IntersectionObserver(entries => {
        entries.forEach(e => ratios.set(cards.indexOf(e.target), e.intersectionRatio));
        if (desk.matches) sync();
      }, {root: rail, threshold: [0, .25, .55, .75, 1]});
      cards.forEach(c => railObs.observe(c));
      viewObs = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; if (!inView) manual.clear(); sync(); }, {threshold: .35});
      viewObs.observe(root);
    }
    instances.set(root, {destroy: () => { life.abort(); railObs?.disconnect(); viewObs?.disconnect(); cards.forEach(pause); instances.delete(root); }});
    on(desk, 'change', sync); on(motion, 'change', sync);
    on(document, 'visibilitychange', () => { if (document.hidden) cards.forEach(pause); else sync(); });
    rail.classList.add('bxv-jump');
    goTo(cards[active], false);
    requestAnimationFrame(() => { rail.classList.remove('bxv-jump'); sync(); });
  };
  const roots = t => t.querySelectorAll('[data-bxv]');
  const boot = () => { place(); roots(document).forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true}); else boot();
  document.addEventListener('shopify:section:load', e => roots(e.target).forEach(init));
  document.addEventListener('shopify:section:unload', e => roots(e.target).forEach(r => instances.get(r)?.destroy()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brellano-mini"]) return;
  try {
    
if (!customElements.get('brellano-mini')) {
  customElements.define('brellano-mini', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const config = JSON.parse(this.querySelector('[data-mini-config]').textContent);
      const form = this.querySelector('.mini-form');
      const variantId = this.querySelector('[data-mini-variant-id]');
      const quantity = this.querySelector('[data-mini-quantity]');
      const add = this.querySelector('[data-mini-add]');
      const addLabel = this.querySelector('[data-mini-add-label]');
      const status = this.querySelector('[data-mini-status]');
      const error = this.querySelector('[data-mini-error]');
      const actions = this.querySelector('[data-mini-added]');
      let busy = false;
      let uncertain = false;
      const selected = () => config.variants.find(variant => String(variant.id) === variantId.value);
      const refreshButton = () => {
        add.disabled = busy || uncertain || !selected()?.available;
        addLabel.textContent = busy ? config.messages.adding : selected()?.available ? config.messages.add : config.messages.soldOut;
        form.setAttribute('aria-busy', String(busy));
        quantity.disabled = busy;
        this.querySelectorAll('[data-mini-choice]').forEach(input => input.disabled = busy);
      };
      const showImage = imageId => {
        const image = config.images.find(item => String(item.id) === String(imageId));
        if (!image) return;
        const update = () => {
        let img = this.querySelector('.mini-hero-image');
        if (!img) {
          img = document.createElement('img');
          img.className = 'mini-hero-image';
          this.querySelector('[data-mini-hero]').replaceChildren(img);
        }
        img.removeAttribute('srcset');
        img.src = image.src;
        img.alt = image.alt;
        img.width = image.width;
        img.height = image.height;
        this.querySelectorAll('[data-mini-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.miniImage === String(image.id))));
        };
        if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.imageTransition?.skipTransition();
          this.imageTransition = document.startViewTransition(update);
          this.imageTransition.finished.catch(() => {});
        } else update();
      };
      const request = async (url, options = {}, timeout = 15000) => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), timeout);
        try {
          const response = await fetch(url, { ...options, credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
          const data = await response.json();
          return { response, data };
        } finally {
          clearTimeout(timer);
        }
      };
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-mini-choice]') || busy) return;
        const variant = config.variants.find(item => String(item.id) === event.target.value);
        if (!variant) return;
        variantId.value = String(variant.id);
        this.querySelector('[data-mini-price]').textContent = variant.price;
        quantity.min = String(variant.min);
        quantity.step = String(variant.step);
        if (variant.max == null) quantity.removeAttribute('max');
        else quantity.max = String(variant.max);
        if (!quantity.checkValidity()) quantity.value = String(variant.min);
        showImage(variant.imageId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        history.replaceState(history.state, '', url);
        if (!uncertain) {
          error.hidden = true;
          status.textContent = variant.title + ' · ' + variant.price + (variant.available ? '' : ' · ' + config.messages.soldOut);
        }
        refreshButton();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-mini-image]');
        if (button && this.contains(button)) showImage(button.dataset.miniImage);
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || uncertain || !selected()?.available || !form.reportValidity()) return;
        const body = new FormData(form);
        body.delete('mini_variant_' + this.dataset.sectionId);
        busy = true;
        error.hidden = true;
        status.textContent = '';
        refreshButton();
        try {
          const { response, data } = await request(config.addUrl, { method: 'POST', body });
          if (!response.ok) {
            if (response.status >= 500) throw new Error('Uncertain cart outcome');
            error.textContent = typeof data.description === 'string' ? data.description : config.messages.failed;
            error.hidden = false;
            return;
          }
          if (!data.id && !Array.isArray(data.items)) throw new Error('Unexpected cart response');
          status.textContent = config.messages.added;
          actions.hidden = false;
          try {
            const cart = await request(config.cartUrl, { cache: 'no-store' }, 8000);
            if (cart.response.ok && Number.isInteger(cart.data.item_count)) document.querySelectorAll('[data-mini-bag-count]').forEach(node => node.textContent = String(cart.data.item_count));
          } catch {}
        } catch {
          uncertain = true;
          error.textContent = config.messages.uncertain;
          error.hidden = false;
          actions.hidden = false;
        } finally {
          busy = false;
          refreshButton();
        }
      });
      this.classList.add('mini-enhanced');
      refreshButton();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
